import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { cn } from "../cn";
import { ChevronLeft, ChevronRight } from "../icons";

export const RD_PAGER_BTN =
  "tw-flex tw-size-8 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-text-foreground tw-shadow-xs tw-transition-colors hover:tw-bg-accent disabled:tw-cursor-not-allowed disabled:tw-opacity-40 disabled:hover:tw-bg-background";

export function RedesignPrevNextPager({
  page,
  total,
  onPageChange,
  hasNext,
  className,
  "data-testid": testId,
}: {
  page: number;
  total?: number;
  onPageChange(next: number): void;
  hasNext?: boolean;
  className?: string;
  "data-testid"?: string;
}) {
  const intl = useIntl();
  const knowsTotal = typeof total === "number";
  const nextEnabled = knowsTotal ? page < total : Boolean(hasNext);

  if (knowsTotal ? total <= 1 : page <= 1 && !nextEnabled) {
    return null;
  }

  return (
    <div className={cn("tw-flex tw-items-center tw-justify-start tw-gap-2", className)} data-testid={testId}>
      <button
        type="button"
        className={RD_PAGER_BTN}
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        aria-label={intl.formatMessage({ id: "redesign.patients.prev", defaultMessage: "Previous" })}
      >
        <ChevronLeft className="tw-size-4" aria-hidden />
      </button>

      {knowsTotal ? (
        <span className="tw-min-w-[3.5rem] tw-px-2 tw-text-center tw-text-sm tw-font-medium tw-tabular-nums tw-text-foreground">
          <FormattedMessage id="redesign.patients.pageOf" defaultMessage="{page} of {total}" values={{ page, total }} />
        </span>
      ) : null}

      <button
        type="button"
        className={RD_PAGER_BTN}
        disabled={!nextEnabled}
        onClick={() => onPageChange(page + 1)}
        aria-label={intl.formatMessage({ id: "redesign.patients.next", defaultMessage: "Next" })}
      >
        <ChevronRight className="tw-size-4" aria-hidden />
      </button>
    </div>
  );
}
